import * as searchActions from '../../actions/early/search'
import * as h2Api from '../../h2Api'

const initialState = {
  isLoading: false,
  term: '',
  hasNext: false,
  hasPrev: false,
  page: 0,
  numResults: -1,
  results: []
}
const search = (state = initialState, action) => {
  switch (action.type) {
    case searchActions.SET_SEARCH_TERM:
      return {
        ...state,
        term: action.searchTerm
      }

    case searchActions.SEARCH_LOADING:
      return {
        ...state,
        isLoading: action.value
      }

    case searchActions.SET_SEARCH_PAGE:
      return {
        ...state,
        page: action.page,
        hasPrev: action.page > 0
      }

    case searchActions.PERFORM_SEARCH:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        return {
          ...state,
          numResults: action.restCall.result.total,
          hasNext: action.restCall.result.hasNext,
          results: action.restCall.result.results
        }
      }

      return state
  }

  return state
}

export default search
